import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../core/withGShoc';
import OntologyIcon from '../core/icons/Ontology';

class OntologyLink extends React.Component {

    render() {

        const { data, defaultLang, id, iconColor } = this.props;
        
        return (
            <Typography data-test="ontology-link" variant="caption" style={{marginTop: 4}}>
                <OntologyIcon fontSize="small" iconColor={iconColor} style={{ verticalAlign: 'bottom', marginRight: 4}} />
                {data.title && data.title[defaultLang] ? data.title[defaultLang] : id}
            </Typography>
        );
    }
}

OntologyLink.defaultProps = {
    iconColor: '#000000'
};

OntologyLink.propTypes = {
    iconColor: PropTypes.string,
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};

export default withGS(OntologyLink);